import React, { useState, useEffect, FC } from "react";
import { Table, Button, Input } from "antd";
import { YHModal } from "@/components/YHModal";
import { ColumnsType, TablePaginationConfig } from "antd/lib/table";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { YhBox } from "@/components/YhBox";
import { ISearchPage } from "@/types/ScmTypes";
import { YhBut } from "@/components/YhButton";
import { RouterParamType } from "@/model/navModel";
import { formatNum } from "@/utils/utils";
import YhTootip from "@/components/YhTootip";
import { useInquiryDetailsMode } from "./inquiryDetailsModel";
import { IInquiryGoodsDetail, IInquiryGoodsSearchField } from "../../inquiryTypes";
import { inquiryService } from "../../inquiryService";
import { transPgToPagination } from "@/model/globalModel";


enum OPT_TYPE {
    ADD = 1,
    REMOVE = 2
}

//为已添加的商品增加 （数量字段,唯一值，商品是否有货位）
export interface ISCMPoSelectGoods
    extends IInquiryGoodsDetail {
    key: string,
    num: number,
    isShelfCode: boolean   //选中的商品有货位不可再次编辑
};

export const AddGoodsModal: FC<RouterParamType> = ({ id, mode }) => {
    const { addGoodsModal: visible, addGoodsList, editGoodsList, setEditGoodsList, setAddGoodsList, setAddGoodsModal,  } = useInquiryDetailsMode();
    //查询条件
    const [searchParam, setSearchParam] = useState<IInquiryGoodsSearchField>({});
    //列表数据源
    const [dataSource, setDataSource] = useState<IInquiryGoodsDetail[]>([]);
    const [goodsList, setGoodsList] = useState<IInquiryGoodsDetail[]>([])
    //列表数据源分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: 10, current: 1 }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [bool, setBool] = useState<boolean>(false);  //用变量来触发全局事件 ， 否咋拿不到全局状态里面的缓存数据
    const [loading, setLoadding] = useState<boolean>(false);
    const onCancel = () => {
        setAddGoodsModal(false);
    };

    let loadData = async (page?: ISearchPage,) => {
        setLoadding(true);
        const newSearchParam = {...searchParam}
        setSearchParam(newSearchParam)
        try {
            const searchParams = {
                ...newSearchParam,
                pageSize: page?.pageSize ?? pgCfg.pageSize,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current
            }
            let { retData } = await inquiryService.materialPage(searchParams);
            const { records, ...pg } = retData;
            setPgCfg(transPgToPagination(pg));
            setDataSource(records);
            setLoadding(false);
        } catch (err) { setLoadding(false) }
    }

    const onGlobalKeyUp = (e: KeyboardEvent) => {
        if (e.ctrlKey && e.keyCode === 13) {
            setBool(origin => !origin);
        }
    };

    useEffect(() => {
        bool && transformsToPoGoods(goodsList, mode)
    }, [bool]);

    //注册window的crtl+回车事件来触发当前 弹框确认事件
    useEffect(() => {
        if (visible) {
            document.onkeyup = onGlobalKeyUp;
            loadData();
        }
        else {
            setGoodsList([])
            // console.log("卸载事件")
            document.onkeyup = null;
            setBool(false);
        }
    }, [visible])

    useEffect(() => {
        return () => {
            document.onkeyup = null;
            setBool(false);
        }
    }, []);


    const addGoods = (record: IInquiryGoodsDetail, ) => {
        if(goodsList.findIndex(i => i.id === record.id) === -1){
           setGoodsList((origin) => [...origin, record])
        }
    }

    const removeGoods = (record: IInquiryGoodsDetail) => {
        setGoodsList(goodsList.filter((item) => item.id !== record.id))
    }

    const transformsToPoGoods = (selectList: IInquiryGoodsDetail[], mode: string) => {
        const isEdit: boolean = mode === 'edit'
        let list = isEdit ? [...editGoodsList] : [...addGoodsList]
        selectList.forEach(item => {
            if(list.findIndex(i => i.id === item.id) === -1){
                const {code: materialCode, name: materialName, unitName, brandName, model, id} = item
                list.push({ id,  materialCode, materialName, unitName, brandName, model, price: 0  })
            }
        })
        isEdit ? setEditGoodsList(list) : setAddGoodsList(list)
        setAddGoodsModal(false)
    }

    const column = (optype: number) => [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            align: "center",
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '商品名称',
            width: 140,
            dataIndex: 'name',
            fixed: "left",
            render: (text: any) => <YhTootip text={text} />,
        },{
            title: '商品编号',
            width: 140,
            dataIndex: 'code',
            fixed: "left",
            render: (text: any) => <YhTootip text={text} />,
        }, 
       {
            title: '单位',
            width: 140,
            dataIndex: 'unitName',
        }, {
            title: '品牌',
            width: 140,
            dataIndex: 'brandName',
        }, 
        {
            title: '操作',
            width: 80,
            fixed: "right",
            align: "center",
            className: "td-wrap",
            render: (text: any, record: any) => optype === OPT_TYPE.ADD ?
                <YhBut
                    type="add"
                    txt="添加"
                    click={() => {
                        addGoods(record)
                    }}
                />
                :
                <YhBut
                    type="delete"
                    txt="删除"
                    click={() => removeGoods(record)}
                />
        }
    ];

    const newSelectColumns = column(OPT_TYPE.REMOVE).map((col: any, index) => {
        return {
            ...col,
            onCell: (record: ISCMPoSelectGoods, rowIndex: number) => ({
                colIndex: index,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                editable: col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑
    const handleSave = (row: ISCMPoSelectGoods) => {
       
    }

    const rightChildren = <div className="flex">
        <Input
            allowClear
            datatype="round"
            className="border-r-16"
            placeholder="商品编号"
            value={searchParam?.code}
            onChange={(e) => setSearchParam({ code: e.target.value })}
            onPressEnter={() => loadData(initPgCfg)}
        />
        <Input
            allowClear
            datatype="round"
            className="border-r-16"
            placeholder="商品名称"
            value={searchParam?.name}
            onChange={(e) => setSearchParam({ name: e.target.value })}
            onPressEnter={() => loadData(initPgCfg)}
        />
        <Button style={{ margin: "0px 12px 0px 15px" }} shape="round" onClick={() => loadData(initPgCfg)}>检索</Button>
    </div >


    return <YHModal
        visible={visible}
        okText="确认添加"
        onOk={() => transformsToPoGoods(goodsList, mode)}
        onCancel={onCancel}
        title="采购单-选择配件"
        width={1000}
        bodyHeight={700}
        showFooter={true}
    >
        <YhBox title="待选配件列表" rightChildren={rightChildren} style={{ marginBottom: "5px", paddingBottom: 0 }}>
            <Table
                loading={loading}
                rowKey={record => record.id}
                columns={column(OPT_TYPE.ADD) as ColumnsType<IInquiryGoodsDetail>}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    }
                }}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
        <YhBox title="已选配件列表">
            <Table
                rowKey={record => record.id}
                rowClassName='editable-row yh-edit-table-tr'
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newSelectColumns}
                dataSource={goodsList}
                pagination={false}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    </YHModal>
}